import React from 'react';
import { observer } from 'mobx-react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import { Catalogue } from '@singularsystems/neo-react-services';
import TitleCatalogueEntry from '../../Catalogue/GenericComponents/TitleCatalogueEntry';
import InternalApproversVM from '../InternalApproversVM';
import InternalApprover from '../../../Models/Approvals/InternalApprover';

interface IInternalApproversEditModalProps {
    viewModel: InternalApproversVM;
}

@observer
export default class InternalApproversEditModal extends React.Component<IInternalApproversEditModalProps> {

    constructor(props: IInternalApproversEditModalProps) {
        super(props);
    }

    public render() {
        const { viewModel } = this.props;

        return (
            <div>
                <Neo.Modal
                    title="Contact"
                    size="lg"
                    bindModel={viewModel.meta.editItem}
                    acceptButton={{ text: "Save", icon: "save", onClick: () => viewModel.saveInternalApprover() }}>
                    {(item: InternalApprover) => (
                        <div>
                            <Neo.GridLayout>
                                <div>
                                    <Catalogue.FormGroupInline bind={item.values.meta.titleId} catalogueType={TitleCatalogueEntry} />
                                    <Neo.FormGroupInline bind={item.values.meta.firstName} />
                                    <Neo.FormGroupInline bind={item.values.meta.lastName} />
                                    <Neo.FormGroupInline bind={item.values.meta.emailAddress} />
                                </div>
                                <div>
                                    <Neo.FormGroupInline bind={item.values.meta.phoneNo} />
                                    <Neo.FormGroupInline bind={item.values.meta.secondaryPhoneNo} />
                                </div>
                            </Neo.GridLayout>
                            <NeoGrid.Grid items={item.users} addButton={{ text: "Link User"}} className="mt-4">
                                {(portalUser, meta) => (
                                    <NeoGrid.Row>
                                        <NeoGrid.Column bindContext={meta.portalUserId} label="User">
                                            <Neo.AutoCompleteDropDown
                                                bind={meta.portalUserId}
                                                items={viewModel.portalUserLookupDataSource}
                                                filterPredicate={item => item.isAuthorised}
                                                placeholder="Name" />
                                            </NeoGrid.Column>
                                        <NeoGrid.ButtonColumn showDelete />
                                    </NeoGrid.Row>
                                )}
                            </NeoGrid.Grid>
                        </div>
                    )}
                </Neo.Modal>
            </div>
        );
    }
}